import { useMutation } from "@tanstack/react-query";

import { quotaQueryClient } from "app/pages/sales-intelligence/modules/quota/queries/client";
import type { ResponseError } from "app/services/fetchService/defaults";

import type { CrmEnrichmentJob, CrmEnrichmentJobDTO } from "../../../../types/types";
import { useSfEnrichmentJobCache } from "../../hooks/useSfEnrichmentJobCache";
import sfEnrichmentApiService from "../../services/api/sfEnrichmentApiService";

export default function useSfEnrichmentJobCreateMutation() {
    const { addNewJobToCache } = useSfEnrichmentJobCache();

    return useMutation<CrmEnrichmentJob, ResponseError, CrmEnrichmentJobDTO>({
        mutationFn: sfEnrichmentApiService.createJob,
        onSuccess: (data) => {
            addNewJobToCache(data);
            void quotaQueryClient.invalidateDataCreditsState();
        },
    });
}
